import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import StyledComponents from './StyledComponents';
import ClientProvider from './client';
export default createDemo(import.meta.url, StyledComponents, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/integrations/interoperability/demos/styled-components/StyledComponents.tsx",
    "fileName": "StyledComponents.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { styled } from '@mui/material/styles';\nimport Slider from '@mui/material/Slider';\nimport Box from '@mui/material/Box';\n\nconst SliderCustomized = styled(Slider)`\n  color: #20b2aa;\n\n  :hover {\n    color: #2e8b57;\n  }\n`;\n\nexport default function StyledComponents() {\n  return (\n    <Box sx={{ width: 300 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Slider defaultValue={30} />\n      <SliderCustomized defaultValue={30} />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 20,
        "focusedLines": 2,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { styled } from '@mui/material/styles';\nimport Slider from '@mui/material/Slider';\nimport Box from '@mui/material/Box';\n\nconst SliderCustomized = styled(Slider)`\n  color: #20b2aa;\n\n  :hover {\n    color: #2e8b57;\n  }\n`;\n\nexport default function StyledComponents() {\n  return (\n    <Box sx={{ width: 300 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Slider defaultValue={30} />\n      <SliderCustomized defaultValue={30} />\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Slider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "defaultValue"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "30"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "SliderCustomized"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "defaultValue"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "30"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 20,
    "focusedLines": 2,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Slider",
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
